import React from 'react'
import CalendarWeek from './CalendarWeek'

class Calendar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      summaryDataDate: props.summary_date,
    }
  }

  displaySummary(date) {
    if (date == this.state.summaryDataDate) {
      this.setState({ summaryDataDate: '' })
    } else {
      this.setState({ summaryDataDate: date })
    }
  }

  renderCalendarWeek (weekData, index) {
    return (
      <CalendarWeek
        data={weekData}
        key={index}
        displaySummary={this.displaySummary.bind(this)}
        summaryDataDate={this.state.summaryDataDate}
        manageTimelineData={this.props.manageTimelineData}
        handleItemClick={this.props.handleItemClick}
        display_modal={this.props.display_modal}
        show_paid_leave={this.props.show_paid_leave}
        show_job_protected_leave={this.props.show_job_protected_leave}
        onHelpfulCheck={this.props.onHelpfulCheck}
        handleJustLookingClick={this.props.handleJustLookingClick}
        show_hidden_tasks={this.props.show_hidden_tasks}
        handleCustomTaskDelete={this.props.handleCustomTaskDelete}
        handleCustomTaskClick={this.props.handleCustomTaskClick}
        custom_task_modal={this.props.custom_task_modal}
        handleCustomTaskChange={this.props.handleCustomTaskChange}
        isLeavePlanPartner={this.props.isLeavePlanPartner}
      />
    )
  }

  render () {
    return (
      <div>
        {this.props.data.map((weekData, index) => this.renderCalendarWeek(weekData, index))}
      </div>
    )
  }
}

export default Calendar;
